import React from 'react'
import { md } from '../lib/remarkable'

function Markdown ({ children }) {
  return <React.Fragment>{md.render(children)}</React.Fragment>
}

export default Markdown
